import css from 'styled-jsx/css';

const styles = css.global`/* #emp-garantia-carro-banner {
    background: #FBFBFB;
  } */
  
  #emp-garantia-carro-banner.stacked-banner {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
    position: relative;
  }
  
  #emp-garantia-carro-banner .bg-image-wrapper {
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
  }
  
  #emp-garantia-carro-banner .bg-image-wrapper picture {
    display: flex;
    width: 100%;
    height: 100%;
  }
  
  #emp-garantia-carro-banner .bg-image-wrapper picture img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right;
  }
  #emp-garantia-carro-banner .fade-banner {
    opacity: 0.25;
    background: var(--Red-Red-Boston-01, #C00);
    position: absolute;
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
  }
  #emp-garantia-carro-banner .fade-banner-gradiente {
    background: linear-gradient(90deg, #900 0%, rgba(153, 0, 0, 0.73) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
    position: absolute;
  }
  
  #emp-garantia-carro-banner .santander-symbol {
    background-image: url(assets/c2c/banners/santander-symbol.svg);
    width: 100%;
    height: 280px;
    position: absolute;
    left: -90px;
    background-repeat: no-repeat;
    background-size: contain;
  }
  
  #emp-garantia-carro-banner .text-box-position {
    margin-top: -200px;
    position: relative;
  }
  
  #emp-garantia-carro-banner .text-box {
    background: #990000;
    width: 100%;
    max-width: 849px;
    padding: 24px 16px 40px 16px;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  #emp-garantia-carro-banner .text-box .main-text {
    font-family: 'SantanderHeadline';
    font-size: 40px;
    font-weight: 400;
    line-height: 60px;
    text-align: left;
    margin-bottom: 8px;
    margin-bottom: 8px;
    color: #fff;
  }
  
  #emp-garantia-carro-banner .text-box .alt-text {
    font-family: 'SantanderText';
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    margin-bottom: 24px;
    color: #fff;
    max-width: 630px;
  }

  #emp-garantia-carro-banner .text-box .alt-text b {
    font-weight: 600;
  }
  
  #emp-garantia-carro-banner .emp-garantia-carro-btns {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
  #emp-garantia-carro-banner .text-box .btn-simulate,
  #emp-garantia-carro-banner .text-box .btn-entrar {
    box-sizing: border-box;
    height: 48px;
    width: 200px;
  }
  
  
  @media (min-width: 992px) {
    #emp-garantia-carro-banner .text-box {
      padding: 24px 47px;
    }
  
    #emp-garantia-carro-banner .santander-symbol { 
      left: 0;
      width: 537px;
      height: 500px;
    }
  
    #emp-garantia-carro-banner .bg-image-wrapper,
    #emp-garantia-carro-banner .fade-banner,
    #emp-garantia-carro-banner .fade-banner-gradiente {
      height: calc(100vh - 180px);
      max-height: 436px;
      min-height: 300px;
    }

    #emp-garantia-carro-banner .emp-garantia-carro-btns {
      flex-direction: row;
      gap: 19px;
    }
  }
  /* @media (min-width: 1200px) {
    #emp-garantia-carro-banner .bg-image-wrapper picture img {
      object-position: 0 40%;
    } 
  }
  
  @media (min-width: 1600px) {
    #emp-garantia-carro-banner .bg-image-wrapper picture img {
      object-position: 0 40%;
    } 
  }
  
  @media (min-width: 1900px) {
    #emp-garantia-carro-banner .bg-image-wrapper picture img {
      object-position: 0 39%;
    } 
  } */`;

export default styles;